import Vue from 'vue';
import { Component, Inject, Prop, Emit, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import WeekComponent from '@/components/week.vue';
import TaskComponent from '@/components/task.vue';
import TaskHeaderComponent from '@/components/task-header.vue';
import ChangePeriodModal from '@/components/change-period-modal.vue';

import { ProjectAction } from '@/models/project-action';

import { Category, Task, Week, DisplayOptions, Project, LoadProjectOptions, Employee } from '@/types/store-types';
import { ProjectStatus } from '@/types/crm-types';

const project = namespace('project');

@Component({ components: { ChangePeriodModal, TaskHeaderComponent, TaskComponent, WeekComponent } })
export default class ProjectView extends Vue {
  private activeSource?: Element = undefined;

  @project.Getter('project')
  private project: Project;

  @project.Getter('categories')
  private categories: Category[];

  @project.Getter('tasks')
  private tasks: Task[];

  @project.Getter('weeks')
  private weeks: Week[];

  @project.Getter('employeeList')
  private employeeList: Employee[];

  @project.Getter('displayOptions')
  private displayOptions: DisplayOptions;

  @project.Mutation('clearState')
  private ClearState() {
  }

  @project.Action('loadProject')
  private async LoadProject(options: LoadProjectOptions) {
  }

  @project.Action('loadAdditionalProjectData')
  private async LoadAdditionalProjectData(options: LoadProjectOptions) {
  }

  @project.Action('getEmployees')
  private async GetEmployees() {
  }

  private tasksForCategory(key: string): Task[] {
    return this.tasks.filter((t) => t.categoryKey === key);
  }

  get endDate(): string {
    if (this.project.endDate) {
      return `${this.$dayjs(this.project.endDate).format('DD-MM-YYYY')}`;
    }

    return '';
  }

  get status(): string {
    switch (this.project.status) {
      case ProjectStatus.Concept:
        return this.$t('status.concept').toString();
      case ProjectStatus.InProgress:
        return this.$t('status.inprogress').toString();
      case ProjectStatus.Completed:
        return this.$t('status.completed').toString();
      default:
        return this.$t('status.unknown').toString();
    }
  }

  get displayRange(): string {
    return `${this.$dayjs(this.displayFirstDate).format('DD-MM-YYYY')} t/m ${this.$dayjs(this.displayLastDate).format('DD-MM-YYYY')}`;
  }

  get displayFirstDate(): Date {
    if (this.weeks === undefined || this.weeks.length === 0) {
      return new Date();
    }

    return this.weeks[0].firstDay;
  }

  get displayLastDate(): Date {
    if (this.weeks === undefined || this.weeks.length === 0) {
      return new Date();
    }

    const firstDayOfLastWeek = this.weeks[this.weeks.length - 1].firstDay;
    const day = new Date(firstDayOfLastWeek);
    day.setDate(day.getDate() + 6);

    return day;
  }

  private async beforeMount() {
    await this.LoadProject({
      projectId: this.$route.params.projectId,
    });

    await this.GetEmployees();
  }

  private async beforeDestroy() {
    this.ClearState();
  }

  private mouseEnter(e: any) {
    const act = e.target as Element;
    this.activeSource = act;
  }

  private scroll(e: any) {
    const act = e.target as Element;
    const left = act.scrollLeft;

    document.querySelectorAll(`.weeksContainer:not([id="${act.id}"])`).forEach((el) => {
      if (el !== this.activeSource) {
        el.scrollLeft = left;
      }
    });

    if (act.scrollWidth - act.clientWidth - act.scrollLeft === 0) {
      if (act === this.activeSource) {
        const startDate = new Date(this.displayLastDate);
        startDate.setDate(this.displayLastDate.getDate() + 1);

        const endDate = new Date(this.displayLastDate);
        endDate.setDate(this.displayLastDate.getDate() + 84);

        this.LoadAdditionalProjectData({
          projectId: this.$route.params.projectId,
          startDate,
          endDate,
        });
      }
    }
  }

  @Emit()
  private actionExecuted() { }

  @Watch('executeAction')
  private async onExecuteActionChanged(val: ProjectAction, oldVal: ProjectAction) {
    switch (val) {
      default: {

      }
    }
  }
}
